/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LabourCode
 */
export interface LabourCode {
    /**
     * 
     * @type {string}
     * @memberof LabourCode
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LabourCode
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LabourCode
     */
    code: string | null;
    /**
     * 
     * @type {string}
     * @memberof LabourCode
     */
    workPackageId: string;
}

/**
 * Check if a given object implements the LabourCode interface.
 */
export function instanceOfLabourCode(value: object): value is LabourCode {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('workPackageId' in value) || value['workPackageId'] === undefined) return false;
    return true;
}

export function LabourCodeFromJSON(json: any): LabourCode {
    return LabourCodeFromJSONTyped(json, false);
}

export function LabourCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LabourCode {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'code': json['code'],
        'workPackageId': json['workPackageId'],
    };
}

export function LabourCodeToJSON(value?: LabourCode | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'code': value['code'],
        'workPackageId': value['workPackageId'],
    };
}

